import React from 'react';
import { Table, Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { prependTimeWithZero } from '../../../utils/CommonUtils';

const ScheduledSettingsTable = (props) => {
    let thStyle = { backgroundColor: 'rgba(204, 204, 204, 0.24)' };

    const renderPreparationTimeDayColumn = (validOnThatDay) => {
        if (validOnThatDay) {
            return (
                <MaterialIcon icon="check" color="rgb(117, 159, 46)" size={28} />
            );
        } else {
            return null;
        }
    }

    return (
        <Table responsive style={{ width: 'calc(100% - 10px)' }}>
            <thead>
                <tr>
                    <th style={thStyle}>{i18n.t('screens:jobsHistoryScreen.scheduledAt')}</th>
                    <th style={thStyle}>{i18n.t('screens:preparationTimes.mon')}</th>
                    <th style={thStyle}>{i18n.t('screens:preparationTimes.tue')}</th>
                    <th style={thStyle}>{i18n.t('screens:preparationTimes.wed')}</th>
                    <th style={thStyle}>{i18n.t('screens:preparationTimes.thu')}</th>
                    <th style={thStyle}>{i18n.t('screens:preparationTimes.fri')}</th>
                    <th style={thStyle}>{i18n.t('screens:preparationTimes.sat')}</th>
                    <th style={thStyle}>{i18n.t('screens:preparationTimes.sun')}</th>
                    <th style={thStyle}>{i18n.t('screens:systemControlContainer.capacity')}</th>
                    <th style={thStyle}></th>
                </tr>
            </thead>
            <tbody>
                {
                    props.databaseData.scheduledSettings.map((setting, index) => {

                        const prependTime = `${prependTimeWithZero(setting.scheduleAtHour)}:${prependTimeWithZero(setting.scheduleAtMinute)}`;
                        const tdStyle = {};

                        return (
                            <tr key={`scheduledSetting${index}`}>
                                <td style={tdStyle}>{prependTime}</td>
                                <td style={tdStyle}>{renderPreparationTimeDayColumn(setting.validOnMonday)}</td>
                                <td style={tdStyle}>{renderPreparationTimeDayColumn(setting.validOnTuesday)}</td>
                                <td style={tdStyle}>{renderPreparationTimeDayColumn(setting.validOnWednesday)}</td>
                                <td style={tdStyle}>{renderPreparationTimeDayColumn(setting.validOnThursday)}</td>
                                <td style={tdStyle}>{renderPreparationTimeDayColumn(setting.validOnFriday)}</td>
                                <td style={tdStyle}>{renderPreparationTimeDayColumn(setting.validOnSaturday)}</td>
                                <td style={tdStyle}>{renderPreparationTimeDayColumn(setting.validOnSunday)}</td>
                                <td style={{ textAlign: 'center' }}>{setting.capacity}</td>
                                <td style={{ width: '140px', textAlign: 'center' }}>
                                    <Button 
                                        color="link"
                                        onClick={() => props.toggle('Settings', setting)}
                                    >
                                        <MaterialIcon icon="edit" color="rgb(2, 136, 209)" size={28} />
                                    </Button>
                                    <Button 
                                        color="link" 
                                        onClick={() => props.toggle('DelConfirmation', setting)}
                                        // onClick={() => props.deleteScheduledSetting(setting.id, () => props.getAllScheduledSettings())}
                                        >
                                        <MaterialIcon icon="delete" color="rgb(2, 136, 209)" size={28} />
                                    </Button>
                                </td>
                            </tr>
                        );
                    })
                }
            </tbody>
        </Table>
    );
}

export default ScheduledSettingsTable;


// WEBPACK FOOTER //
// ./src/components/systemControl/database/ScheduledSettingsTable.js